import type { LumberPiecesByProfile } from "./lumberTypes";

export enum RoofFramingComponentType {
  RIDGE = "RIDGE", //peak of the roof
  HIP = "HIP",
  KING = "KING", //rafters connecting to vertex of the ridge rafters
  COMMON = "COMMON", //rafters connecting to ridge rafters
  JACK = "JACK", //rafters connecting to hip rafters
  EAVE = "EAVE",
  RAKE = "RAKE",
  VALLEY_JACK = "VALLEY_JACK",
  GENERIC = "GENERIC",
  WEB = "WEB",
  BOTTOM_CHORD = "BOTTOM_CHORD",
  TOP_CHORD = "TOP_CHORD",
  LOOKOUT = "LOOKOUT",
}

export interface RoofFramingComponentBase<T extends RoofFramingComponentType> {
  readonly type: T;
}

export interface RoofFramingComponent extends RoofFramingComponentBase<RoofFramingComponentType> {
  readonly lumber: LumberPiecesByProfile;
}
